import "@/index.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { ProtectedRoute } from "@/components/admin/ProtectedRoute";
import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Financing from "@/pages/Financing";
import Contact from "@/pages/Contact";
import Reviews from "@/pages/Reviews";
import Peptides from "@/pages/Peptides";
import BeforeAfter from "@/pages/BeforeAfter";
import GLP1 from "@/pages/GLP1";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/Login";
import ForgotPassword from "@/pages/admin/ForgotPassword";
import ResetPassword from "@/pages/admin/ResetPassword";
import Dashboard from "@/pages/admin/Dashboard";
import ContentManager from "@/pages/admin/ContentManager";
import Account from "@/pages/admin/Account";

function App() {
  return (
    <AuthProvider>
      <ContentProvider>
        <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/financing" element={<Financing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/peptides" element={<Peptides />} />
            <Route path="/before-after" element={<BeforeAfter />} />
            <Route path="/glp1" element={<GLP1 />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/forgot" element={<ForgotPassword />} />
          <Route path="/admin/reset-password" element={<ResetPassword />} />
          <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/admin/content" element={<ProtectedRoute><ContentManager /></ProtectedRoute>} />
          <Route path="/admin/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
        </Routes>
        </BrowserRouter>
      </ContentProvider>
    </AuthProvider>
  );
}

export default App;
